/* eslint-disable */
import { useState } from "react";
import { useEffect } from "react";
import ReactPlayer from 'react-player/lazy';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import ImageIcon from '@mui/icons-material/Image';
import VideoCameraBackIcon from '@mui/icons-material/VideoCameraBack';
import FileDownloadIcon from "components/FileDownloadIcon"
import PdfViewer from "components/pdf/PdfViewer"
import { fileAccepts } from 'data/data';
import { Button, CardContent, Modal } from "@mui/material";
import MainCard from "components/MainCard";
import { useTranslation } from "react-i18next";

const FileLayer = ({file, printRef}) => {
    const { t } = useTranslation();

    const [open, setOpen] = useState(false);
    
    const handleOpen = () => {
        setOpen(true);
        // downFromFile();
    }
    const handleClose = () => setOpen(false);

    const [accept, setAccept] = useState(null);
    const [fileUrl, setFileUrl] = useState(null);
    
    useEffect(()=>{
        downFromFile();
    },[file]);

    const downFromFile = () => {
        // console.log(file)
        if (file) {
            const extension = file.originFile.substring(file.originFile.lastIndexOf(".")).toLowerCase();
            setAccept(fileAccepts.filter(acc => acc.extension.indexOf(extension) !== -1)[0]);
            setFileUrl(window.RUNTIME_CONFIG.REACT_APP_API_URL+"/api/download/"+file.id);
        }
    }
// console.log(accept)
    // if (!isLayer) {
        if (file && fileUrl && accept && accept.code === 'I') {
            return (
                <>
                <ImageIcon onClick={handleOpen} style={{minWidth:"unset",color:"#fff", cursor:"pointer"}} />

                <Modal className="pop_box" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    <MainCard 
                        title="" modal darkTitle content={false}>
                        <CardContent style={{height:"100%"}}>
                            <div className='pop_close'>
                                <Button color="primary" size="small" onClick={handleClose}>
                                    {t('message.common.btn.close')}
                                </Button>
                            </div>
                            
                            <div ref={printRef} style={{position:"relative", width:"100%",/* height:"500px",*/ maxHeight:"500px", overflow:"auto", textAlign:"center", padding:"10px"}}>
                                <img src={fileUrl} style={{maxWidth:"100%"}}/>
                            </div>

                        </CardContent> 
                    </MainCard>
                </Modal>
                </>
            )
        }

        if (file && accept && accept.code === 'M') {
            return (
                <>
                <VideoCameraBackIcon onClick={handleOpen} style={{minWidth:"unset",color:"#fff", cursor:"pointer"}} />

                <Modal className="pop_box" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    <MainCard 
                        title="" modal darkTitle content={false}>
                        <CardContent style={{height:"100%"}}>
                            <div className='pop_close'>
                                <Button color="primary" size="small" onClick={handleClose}>
                                    {t('message.common.btn.close')}
                                </Button>
                            </div>
                            
                            <div ref={printRef} className='player-wrapper' style={{width:'100%'}}>
                                <ReactPlayer
                                    className='react-player'
                                    controls
                                    url={fileUrl}
                                    width='100%'
                                    height='100%'
                                    playing={true}
                                    loop={true}
                                />
                            </div>

                        </CardContent> 
                    </MainCard>
                </Modal>
                </>
            )
        }
    // }

    if (file && accept && accept.code === 'P') {
        return (
        <>
        <SpeakerNotesIcon onClick={handleOpen} style={{minWidth:"unset",color:"#fff", cursor:"pointer"}} />

        <Modal className="pop_box" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <MainCard 
                title="" modal darkTitle content={false}>
                <CardContent style={{height:"100%"}}>
                    <div className='pop_close'>
                        <Button color="primary" size="small" onClick={handleClose}>
                            {t('message.common.btn.close')}
                        </Button>
                    </div>
                    
                    <PdfViewer fileUrl={fileUrl} isLayer={true} />

                </CardContent> 
            </MainCard>
        </Modal>
        </>
        )
    }

    if (file && accept && accept.code === 'E') {
    // if (file) {
        return (
            <div ref={printRef} style={{position:"relative", width:"100%",/* height:"500px",*/ maxHeight:"500px", overflow:"auto", textAlign:"center", padding:"10px"}}>
            {/* <div ref={printRef} style={{position:"relative", width:"100%", height:"500px"}}>
                <div style={{ top:"45%", left:"50%", position:"absolute"}}> */}
                    <FileDownloadIcon file={file} iconSize="large" />
                    {/* <div style={{marginLeft:"-50%"}}>{file.originFile}</div> */}
                {/* </div> */}
            </div>
        )
    }
}

export default FileLayer;